import { render } from "./TrainerUpdateModal.vue?vue&type=template&id=22e8ba68&scoped=true"
import script from "./TrainerUpdateModal.vue?vue&type=script&lang=js"
export * from "./TrainerUpdateModal.vue?vue&type=script&lang=js"

import "./TrainerUpdateModal.vue?vue&type=style&index=0&id=22e8ba68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e8ba68"]])

export default __exports__